import { apiGet, baseUrl, getAuthHeaders } from "./api.service";

const returnUrl = `${window.location.origin}/profile`;

export async function managePayments() {
    const options = {
        method: 'POST',
        contentType: 'application/json',
        body: JSON.stringify({ returnUrl: returnUrl }),
    }
    const response = await fetch(baseUrl + '/payments/portal', {
        ...options,
        headers: await getAuthHeaders(),
    });
    if (!response.ok) {
        throw new Error(`API request failed: ${await response.text()}`);
    }
    return response.json();
}

export async function upgradeAccount() {
    const options = {
        method: 'POST',
        contentType: 'application/json',
        body: JSON.stringify({
            "priceId": "price_1RX2gm04TXRqA8X2utBYJtu5",
            "successUrl": returnUrl,
            "cancelUrl": returnUrl
        }),
    }
    const response = await fetch(baseUrl + '/payments/checkout', {
        ...options,
        headers: await getAuthHeaders(),
    });

    if (!response.ok) {
        throw new Error(`API request failed: ${await response.text()}`);
    }

    return response.json();
}

// export async function getUserSubscription() {
//     return apiGet(`/users/subscription`);
// }

export async function getUserStats() {
    return apiGet('/users/stats');
}